import { DragEvent, TouchEvent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import styles from "./BlockGridInput.module.css";
import { Block } from "./BlockGridInput";
import { useIconPack } from "../../context/IconPackContext";

interface GridBlockProps {
  block: Block;
  index: number;
  isDragging: boolean;
  disabled: boolean;
  onDragStart: (e: DragEvent<HTMLDivElement>) => void;
  onDragEnd: () => void;
  onDragOver: (e: DragEvent<HTMLDivElement>) => void;
  onDragEnter: () => void;
  onDrop: (e: DragEvent<HTMLDivElement>) => void;
  onTouchStart: (e: TouchEvent<HTMLDivElement>) => void;
  onTouchMove: (e: TouchEvent<HTMLDivElement>) => void;
  onTouchEnd: () => void;
  blockClassName?: string;
  blockIconClassName?: string;
  blockLabelClassName?: string;
}

export default function GridBlock({
  block,
  index,
  isDragging,
  disabled,
  onDragStart,
  onDragEnd,
  onDragOver,
  onDragEnter,
  onDrop,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  blockClassName,
  blockIconClassName,
  blockLabelClassName,
}: GridBlockProps) {
  const { getIcon } = useIconPack();

  return (
    <div className={styles.blockWrapper} data-block-index={index}>
      <div
        draggable={!disabled}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        onDragOver={onDragOver}
        onDragEnter={onDragEnter}
        onDrop={onDrop}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        className={`${blockClassName || styles.defaultBlock} ${isDragging ? styles.dragging : ""}`}
        style={{
          cursor: disabled ? "default" : isDragging ? "grabbing" : "grab",
          touchAction: "none",
        }}
      >
        <div className={styles.blockControls}>
          <DragIndicatorIcon className={styles.dragIcon} />
          <span className={styles.blockNumber}>#{index + 1}</span>
        </div>

        <div className={blockIconClassName || styles.defaultIcon}>
          <FontAwesomeIcon icon={getIcon(block.icon || "file")} />
        </div>
        
        <h3 className={blockLabelClassName || styles.defaultLabel}>
          {block.label}
        </h3>
      </div>
    </div>
  );
}